import { DECUPLE, VIGINTUPLE } from "../../../constants/numbers.consts.js";
export const CLIP_PATH_PADDING = DECUPLE;
export const TOOLTIP_OFFSET = VIGINTUPLE;
export const TOOLTIP_PAPER_HEIGHT = 140;
export const TOOLTIP_PAPER_WIDTH = 360;
